/** Numbers the requirements fix. Anything here that is also in `config` is the default value. */
export const H3_RESOLUTION = 9; // FR-LOC-02, ~174 m edge
export const CLUSTER_PIN_ZOOM = 14; // everyone is their own pin at or above this zoom; below it only overlapping pins group
/** A person's pin across, in screen pixels (FR-MAP-03): below the pin zoom, pins closer than this group (decision 169). */
export const MAP_PIN_PX = 44;
/**
 * The most people one map reply draws as their own pins below the pin zoom (decision 169). A phone
 * screen holds about 150 pins side by side, so it never reaches this from overlap alone; past it, the
 * groups widen until the pins fit, crowded places first.
 */
export const MAP_PIN_CAP = 300;
/**
 * Fewer people than this in view on the map's first answer, and a member who has never picked map or
 * grid opens on the grid instead (decision 147): a few pins on a big map look emptier than they are.
 */
export const GRID_START_BELOW = 100;
export const GATE_RADIUS_KM = 50; // FR-GAT-04
/** A waiting member always reaches at least this many eligible reviewers, however far (gateReachKm). */
export const GATE_MIN_REVIEWERS = 3;
export const ANON_EXPIRY_DAYS = 30; // FR-ANO-07
export const ANON_WARN_DAYS = [23, 29];
/**
 * Vouch for me (decision 197): on from sign-up until they turn it off, with no end of its own. Turned on
 * again (or shown again by a new photo) within this long of the last time, it keeps that time, so
 * flipping it can't bring the Wall row back to the top.
 */
export const VOUCH_ASK_REDATE_HOURS = 24;
/** A `?src=` tag on the landing URL (GR-60): what a card, a post or an ambassador's link is counted as. */
export const SIGNUP_SOURCE_RE = /^[a-z0-9][a-z0-9_-]{0,39}$/;
export const INVITE_TTL_DAYS = 7; // FR-INV-01
/** Who an invite is for, in the inviter's words (issue #10): a name, not a note. */
export const INVITE_LABEL_MAX = 60;
/** Shared codes: how many one person may have switched on at once, and the date that stands for "never" */
export const SHARED_INVITES_MAX = 20;
export const SHARED_INVITE_NEVER = '9999-12-31T00:00:00Z';
export const INVITE_FIRST_AFTER_DAYS = 7; // FR-INV-03
export const INVITE_INITIAL_QUOTA = 2;
export const INVITE_QUOTA_STEP_DAYS = 30;
export const INVITE_QUOTA_CAP = 10;
export const VET_ELIGIBLE_AFTER_DAYS = 7; // FR-VET-05: the default; the owner sets it app-wide and per region
/** the longest wait the console allows; members Trusted longer than this skip the region lookup */
export const VET_WAIT_MAX_DAYS = 90;
export const VET_GESTURE_COUNT = 3; // FR-VET-01
export const VET_GESTURE_WINDOW_S = 5;
export const VET_CLIP_MAX_S = 3;
export const VET_CLIP_MAX_BYTES = 2 * 1024 * 1024; // FR-VET-09
export const VET_CAPTURE_TTL_DAYS = 7; // FR-VET-02
export const VET_REDO_LIMIT = 3; // FR-VET-03, per 14 days
export const VET_REDO_WINDOW_DAYS = 14;
export const VET_REVIEW_LOCK_MIN = 15; // FR-VET-04
export const GATEKEEPER_TIERS = [5, 25, 100]; // FR-VET-07
/**
 * The badge for each vetting level, by tier (0 is none). The first stays "Gatekeeper": "Gatekeepers
 * only" (who may message you first, who reviews you) means anyone at level 1 or above.
 */
export const GATEKEEPER_LABEL = ['', 'Gatekeeper', 'Sentinel', 'Guardian'];
/** Connected, Well Connected, Legend (decision 65): Trusted members anywhere in your circle. */
export const CIRCLE_TIERS = [10, 50, 250];
/** The badge for each of those levels, by tier (0 is none). */
export const CIRCLE_LABEL = ['', 'Connected', 'Well Connected', 'Legend'];
/** Scout, Tracker, Trailblazer (decision 67): places a member added that are still on the map. */
export const PLACE_TIERS = [3, 10, 25];
export const PLACE_LABEL = ['', 'Scout', 'Tracker', 'Trailblazer'];
/**
 * Earned Plus (decision 64): this many completed reviews at the Gate, or this many people you brought
 * in who got vetted, in any 30 days, and Plus is free. The owner sets both in the console; 0 turns one off.
 */
export const PLUS_EARN_VETS = 3;
export const PLUS_EARN_INVITES = 2;
export const PLUS_EARN_WINDOW_DAYS = 30;
/**
 * FR-GAT-05's "Gatekeepers only" is offered only with at least this many Gatekeepers able to vet you
 * (bugs.md): with fewer, choosing it could leave a pending member with nobody to let them in.
 */
export const GATEKEEPER_CHOICE_MIN = 5;
/** The chain's leaderboards (by calendar month): the top three, then honorable mentions with more than this many. */
export const LEADER_TOP = 3;
export const LEADER_MENTION_OVER = 5;
/** FR-VET-01: at least twelve; index 0 is the head turn and is always included. */
export const VET_GESTURES = [
    'Turn your head slowly to the left, then the right',
    'Touch your left ear',
    'Touch your right ear',
    'Hold up two fingers',
    'Hold up four fingers',
    'Cover one eye with your hand',
    'Put a thumb on your chin',
    'Stick out your tongue',
    'Raise your eyebrows twice',
    'Tilt your head to one shoulder',
    'Make a fist in front of your chin',
    'Wave at the camera',
    'Pinch the tip of your nose',
];
export const VETTER_STRIKES_LOSE_RIGHTS = 2; // FR-VET-06
export const VETTER_STRIKES_REVIEW = 3;
export const APPEAL_SLA_HOURS = 72; // FR-CHN-05
export const REINSTATED_RESTRICTED_DAYS = 30;
export const ONLINE_WINDOW_MS = 2 * 60 * 1000; // FR-STA-05
export const HEARTBEAT_INTERVAL_MS = 45 * 1000;
export const LOCATION_STALE_MS = 30 * 60 * 1000; // FR-LOC-08
export const LOCATION_EXPIRE_MS = 24 * 60 * 60 * 1000;
export const STATUS_DEFAULT_MS = 2 * 60 * 60 * 1000; // FR-STA-02
export const STATUS_MAX_MS = 12 * 60 * 60 * 1000;
export const STATUS_MAX_PLUS_MS = 24 * 60 * 60 * 1000;
export const KNOCKS_PER_DAY = 5; // FR-KNK-06
export const KNOCK_COOLDOWN_DAYS = 7;
export const CHECKIN_MAX_DISTANCE_M = 300; // decision 24
export const SPOT_FLAG_TTL_HOURS = 12; // TS-10
export const MEDIA_EXPIRE_AFTER_VIEW_MS = 24 * 60 * 60 * 1000; // FR-CHT-03
export const MEDIA_EXPIRE_UNVIEWED_DAYS = 7;
export const MESSAGE_TEXT_TTL_DAYS = 30;
export const ACCOUNT_PURGE_DAYS = 30; // FR-ACC-07
/** how long a member's data export can be downloaded (FR-ACC-07) */
export const EXPORT_KEEP_DAYS = 7;
/** a removed account's email, device and photo hashes, kept to stop it coming back (Privacy Policy §10) */
export const REMOVED_KEEP_YEARS = 5;
/** reports, moderation decisions and appeals, counted from when the case closed (LG-10, Privacy Policy §10) */
export const SAFETY_KEEP_YEARS = 2;
/** a moderator's look at someone's private photos without an open case, once they give a reason (Privacy Policy §6) */
export const PRIVATE_LOOK_MINUTES = 30;
export const SIGNED_URL_TTL_S = 5 * 60; // NFR-SEC-05
export const PUBLIC_PHOTO_MAX = 6; // FR-PRO-04
/** Photos a spot can have, live or being checked (FR-SPT-01; bugs.md: photos of spots). */
export const SPOT_PHOTO_MAX = 12;
export const PRIVATE_PHOTO_MAX = 24;
export const PRIVATE_PHOTO_MAX_PLUS = 100;
export const HEADLINE_MAX = 80;
export const ABOUT_MAX = 500;
/** Into: how many tags a profile carries, the listed ones and your own together (bugs.md: it was 12). */
export const INTO_MAX = 25;
/** Partnered (decision 186): partners on a profile. */
export const PARTNERS_MAX = 5;
export const STATUS_TEXT_MAX = 120;
/** Searching your chats (decision 185) starts at two characters. */
export const INBOX_SEARCH_MIN = 2;
export const SPOT_TEXT_MAX = 300;
export const REPORT_SLA_URGENT_H = 1; // TS-06
export const REPORT_SLA_NORMAL_H = 24;
export const HOLD_AFTER_REPORTS = 3; // TS-18
/** The Wall (FR-WAL-01, 03, 08, 11) */
export const WALL_RADIUS_KM = 25;
export const WALL_WIDE_RADIUS_KM = 50;
/**
 * The launch city (decision 6): the Wall a reader is shown when there's nothing near them, or no pin
 * to measure from (decision 103). The middle of Denver, as its region row has it.
 */
export const LAUNCH_CITY = { name: 'Denver', lat: 39.7392, lng: -104.9903 };
export const WALL_POST_MAX = 280;
/** Wall posts with a photo, per member per day (decision 178), over the post limits */
export const WALL_IMAGE_DAILY_MAX = 10;
/** Why the Wall's attach button is locked, and the server's refusal behind it (decision 178) */
export const WALL_IMAGE_LOCKED = 'Photos on the Wall are for vetted members.';
export const WALL_SAVE_DAYS = 30;
export const WALL_HIDE_AFTER_REPORTS = 3; // FR-WAL-10: independent reports hide a post pending review
export const DISTANCE_BUCKETS_KM = [0.5, 1, 2, 5, 10, 25]; // FR-LOC-04
export const PLUS_PLANS = [
    { id: 'monthly', usd: 15, months: 1 },
    { id: 'half_year', usd: 75, months: 6 },
    { id: 'yearly', usd: 140, months: 12 },
]; // decision 3
export const MEDIA_MAX_EDGE = 2048; // client re-encode (NFR-PWA-04)
export const MEDIA_SERVE_EDGE = 1600;
/** Chat video (FR-CHT-02, the week 5 deferral): up to 30 seconds, 60 MB uploaded, re-encoded to 720p. */
export const VIDEO_MAX_SECONDS = 30;
export const VIDEO_MAX_MB = 60;
export const VIDEO_MAX_BYTES = VIDEO_MAX_MB * 1024 * 1024;
/** The video types an upload may say it is; the worker re-encodes whatever ffprobe can read to MP4. */
export const VIDEO_CONTENT_TYPES = ['video/mp4', 'video/quicktime', 'video/webm'];
export const VIDEO_SERVE_EDGE = 720;
export const MEDIA_THUMB_EDGE = 320;
/** A map pin's photo: 44 px at up to 3x. The map downloads this, not the thumbnail (CDN note). */
export const MEDIA_PIN_EDGE = 132;
export const UPLOAD_URL_TTL_S = 5 * 60;
export const PROFILE_VIEWS_FREE = 50; // FR-PRO-08
export const RECENTS_CAP = 100; // FR-CHT-13
export const RECENTS_CAP_PLUS = 500;
export const RECENTS_TTL_DAYS = 90;
export const MEDIA_ONCE_GRACE_MS = 2 * 60 * 1000; // "gone after they open it": the viewing session
/**
 * FR-CHT-12: the composer's one-tap replies. These are the built-in defaults; the owner sets the
 * defaults everyone gets in the console (`chat.quick_replies`), and each member can write their own.
 */
export const QUICK_REPLIES = ['Heading over', 'Send face', 'Where'];
export const QUICK_REPLY_MAX = 8;
export const QUICK_REPLY_LEN = 40;
export const UNLOCKED_ALBUMS_MESSAGE = 'Unlocked an album';
/**
 * The owner's email to one member, from their page on the console: the starting words for the usual
 * reasons to write. These are the defaults; the owner edits, adds and removes them on console ›
 * Communications (`email.member_templates`). `{handle}` is their handle; a `[bracketed]` part is for
 * you to fill in, and the console won't send one left in without asking. Worded for an ordinary inbox:
 * nothing explicit, in the subject least of all.
 */
export const MEMBER_EMAIL_TEMPLATES = [
    {
        key: 'nudge',
        label: 'Nudge',
        subject: 'Your spot on the map is waiting',
        body: "Hey {handle},\n\nIt's been a while since you were on the map. Your profile is right where you left it, whenever you want back in.\n\nJason",
        button: true,
    },
    {
        key: 'help',
        label: 'Help',
        subject: 'Need a hand with Feral Mode Live?',
        body: "Hey {handle},\n\nIt looks like you got stuck partway: [what you noticed].\n\nIf something isn't working, reply to this email and tell me what you see. I read every one.\n\nJason",
        button: true,
    },
    {
        key: 'response',
        label: 'Response',
        subject: 'About what you sent us',
        body: "Hey {handle},\n\nThanks for writing in. [Your answer.]\n\nIf that doesn't cover it, reply to this email.\n\nJason",
        button: false,
    },
    {
        key: 'note',
        label: 'Note',
        subject: 'A note from Feral Mode Live',
        body: 'Hey {handle},\n\n[Your note.]\n\nJason',
        button: false,
    },
    {
        key: 'reward',
        label: 'Reward',
        subject: 'Something for you',
        body: "Hey {handle},\n\n[What they did] made the map better, and it didn't go unnoticed. [What you're giving them], on the house.\n\nThanks for being part of it.\n\nJason",
        button: true,
    },
    {
        key: 'thanks',
        label: 'Thanks',
        subject: 'Thank you',
        body: "Hey {handle},\n\nThank you for [what they did]. It's people like you who keep the map worth opening.\n\nJason",
        button: false,
    },
    {
        key: 'welcome',
        label: 'Welcome',
        subject: 'Welcome to Feral Mode Live',
        body: "Hey {handle},\n\nWelcome in. I'm Jason, and I run Feral Mode Live. If anything's confusing or broken, reply to this email and I'll sort it out.\n\nJason",
        button: true,
    },
];
export const MEMBER_EMAIL_TEMPLATES_MAX = 12;
export const MEMBER_EMAIL_LABEL_MAX = 24;
export const MEMBER_EMAIL_SUBJECT_MAX = 120;
export const MEMBER_EMAIL_BODY_MAX = 5000;
/** console › Users' selection (decision 182): at most this many members at once, for an action or an email. */
export const BULK_MEMBERS_MAX = 1000;
/**
 * The owner's email to many members (decision 182), one each: this many a minute, so the mail provider
 * (Google Workspace's SMTP for the trial, about 2,000 a day an account) never throttles it, and the sign-in
 * emails sharing that account still go.
 */
export const MEMBER_EMAILS_PER_MINUTE = 20;
/** and at most this many a day, across every such send */
export const MEMBER_EMAILS_PER_DAY = 1000;
// ───────────────────────── Week 8: statuses and spots ─────────────────────────
export const STATUS_EXTEND_MS = 60 * 60 * 1000; // FR-STA-03: one tap adds an hour
/** FR-STA-01: how long "Looking" lasts for each choice */
export const LOOKING_HOURS = { now: 2, today: 8, tonight: 6 };
export const CHECKIN_DEFAULT_H = 1; // FR-SPT-03
export const CHECKIN_MAX_H = 3;
export const CHECKIN_CELL_TOLERANCE_M = 250; // the viewer is somewhere in a cell, not at its centre
export const SPOT_DUPLICATE_M = 100; // FR-SPT-08
export const SPOT_VERIFY_CHECKINS = 5; // FR-SPT-02
export const SPOT_NAME_MAX = 80;
/** A spot's "About" text (FR-SPT-01): room for the longest imported listing (358) and then some. */
export const SPOT_DESCRIPTION_MAX = 500;
/** A spot's tags, listed and its own together, and the length of one (FR-SPT-01). */
export const SPOT_TAGS_MAX = 8;
export const SPOT_TAG_MAX = 24;
/** Notes on a person (FR-PRO-10): free text, and up to this many of each saved detail. */
export const NOTE_TEXT_MAX = 2000;
export const NOTE_DETAILS_MAX = 10;
/**
 * Your own word tags on a note (decision 180): this long each, this many on one note, and this many
 * different ones across all your notes.
 */
export const NOTE_TAG_MAX = 24;
export const NOTE_TAGS_MAX = 10;
export const NOTE_TAGS_DISTINCT_MAX = 100;
/** A tag as kept: trimmed, its spaces collapsed, in the writer's own casing. */
export const tidyNoteTag = (s) => s.replace(/\s+/g, ' ').trim();
/** Two tags are the same tag whatever their casing. */
export const noteTagKey = (s) => tidyNoteTag(s).toLocaleLowerCase();
// The option lists (spot tags, hosting tags, into tags, note marks) live in options.ts.
/**
 * The app and the console each name their window, so a link from one to the other comes back to the
 * window that's already open instead of opening another (browsers clear the name on leaving the site).
 */
export const APP_WINDOW = 'feral-app';
export const MOD_WINDOW = 'feral-mod';
/**
 * Scheduled arrivals (decision 69): when you can say you'll be at a spot, how long after that time it
 * lapses if you never check in, and how far you may be for each: about 80 km an hour of travel, at
 * least a few kilometers, so "10 minutes" from the far side of the state isn't offered.
 */
export const ARRIVAL_MINUTES = [10, 30, 60, 120];
export const ARRIVAL_GRACE_MIN = 30;
export const ARRIVAL_KM_PER_HOUR = 80;
export const arrivalReachM = (minutes) => Math.max(3_000, (minutes / 60) * ARRIVAL_KM_PER_HOUR * 1000);
/**
 * The basemap archive the map and the city pages read (architecture §6.5): the USA, built by
 * infra/tiles/build.sh and served at /tiles/<this> by the dev server and the trial's tile server.
 */
export const BASEMAP_FILE = 'usa.pmtiles';
/** Rows on a page of a console list (bugs.md: long lists page instead of stopping at a silent cap). */
export const CONSOLE_PAGE = 50;
/** The legal documents the owner keeps on the console (bugs.md): published, versioned, accepted. */
export const LEGAL_DOCS = ['terms', 'privacy'];
export const LEGAL_DOC_TITLE = {
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
};
/**
 * Events (FR-EVT-*, decision 91). A title as long as a spot's name; rules as the wireframe counts them
 * (WF-GRP-01); a description, in Markdown, with room to say what the night is; tags as a spot's. An event runs at most 24 hours and can be posted up to two weeks
 * ahead. Its chat holds 200 (FR-CHT-10), so that is the most a host can let in, and it stays open a day
 * after the event ends for the "thanks, everyone". A host has at most three live events at once.
 */
export const EVENT_TITLE_MAX = 60;
export const EVENT_RULES_MAX = 300;
export const EVENT_DESCRIPTION_MAX = 5000;
export const EVENT_TAGS_MAX = 8;
export const EVENT_TAG_MAX = 24;
export const EVENT_MAX_HOURS = 24;
export const EVENT_AHEAD_DAYS = 14;
export const EVENT_CAPACITY_MAX = 200;
export const EVENT_CHAT_AFTER_H = 24;
export const EVENTS_LIVE_MAX = 3;
/**
 * A repeating event (decision 158): "after N times" runs to 100 at most. One date at a time (decision
 * 192): the next is made once the one before it ends or is called off, and its page lists up to 8 of
 * the dates after it, as dates only.
 */
export const EVENT_REPEAT_COUNT_MAX = 100;
export const EVENT_LATER_DATES = 8;
/**
 * An event's address (decision 193): the street address of an in-person one, or a virtual one's link.
 * The host can send Meet requests from 2 hours before it starts; with the address kept for Meet and no
 * requests sent, it shows to whoever's in from 30 minutes before, so nobody is left without it.
 */
export const EVENT_ADDRESS_MAX = 300;
export const EVENT_MEET_SEND_BEFORE_MIN = 120;
export const EVENT_ADDRESS_FALLBACK_MIN = 30;
/**
 * Event invitations by email (decision 159): at most 3 a day to one member, whoever invites them; a
 * moderator's bulk invite (decision 160) reaches one member's inbox once a day at most, across events,
 * and counts toward the 3; a moderator sends 3 bulk invites a day at most.
 */
export const EVENT_INVITE_EMAILS_PER_DAY = 3;
export const EVENT_BULK_EMAILS_PER_DAY = 1;
export const EVENT_BULK_INVITES_PER_DAY = 3;
/** Your groups and events (decision 130) keep the ones you hosted or went to for 30 days after. */
export const MY_EVENTS_PAST_DAYS = 30;
/**
 * Groups (FR-GRP-*, decision 92). A name as long as an event's title; a description as long as a
 * spot's; tags as a spot's. A group holds 200, the chat's cap (FR-CHT-10). A member runs at most five
 * groups, and an admin mutes someone for 24 hours (US-GRP-05).
 */
export const GROUP_NAME_MAX = 60;
export const GROUP_ABOUT_MAX = 500;
export const GROUP_CITY_MAX = 40;
export const GROUP_TAGS_MAX = 8;
export const GROUP_TAG_MAX = 24;
export const GROUP_MEMBERS_MAX = 200;
export const GROUPS_RUN_MAX = 5;
export const ROOM_MUTE_HOURS = 24;
/**
 * FR-CHT-17: how long after sending a member may edit or delete their own message. Short, so a photo
 * can't be sent and quietly taken back once the other person has had time to report it, and an answer
 * can't be changed under a reply long after.
 */
export const MESSAGE_CHANGE_MINUTES = 15;
/**
 * Onboarding after sign-up (FR-ACC-06), in order. A new account starts at `rules` and moves forward one
 * step at a time; `Me.onboarding` is the one it's on, null once it's done (and for every account made
 * before onboarding was tracked). The app opens on that step until it's done (bugs.md). Where they are
 * isn't one of them: it's sign-up's first step, before the age gate, since the region decides so much.
 */
export const ONBOARDING_STEPS = ['rules', 'profile', 'install', 'notify'];
/**
 * A Pending member's way in, as console › Gate draws it (bugs.md): the account, onboarding's steps,
 * then the vet. Each is the furthest they've got; the one after it is where they stopped.
 */
export const GATE_STAGES = [
    'joined',
    'rules',
    'profile',
    'install',
    'notify',
    'recording',
    'submitted',
    'reviewed',
];
/**
 * Hidden on console › Gate when asked (bugs.md): stopped before their profile, with nothing since this
 * long, so they never really started.
 */
export const GATE_EARLY_QUIET_MS = 24 * 60 * 60_000;
/**
 * Reminders to finish signing up (bugs.md): an account that goes quiet for an hour with its profile
 * unfinished, or, Pending, its clips not recorded, gets an email then and once a day after, four in
 * all, each with a sign-in link that works once for a day. Finishing stops them; a Quick Exit stops
 * them for good.
 */
export const SIGNUP_NUDGES = 4;
export const SIGNUP_NUDGE_QUIET_MS = 60 * 60_000;
export const SIGNUP_NUDGE_EVERY_MS = 24 * 60 * 60_000;
export const SIGNUP_NUDGE_LINK_S = 24 * 60 * 60;
/**
 * How long the button in the "You're in" email signs someone in, once (Vet now, decision 139): a day,
 * as the reminders' does. Long enough for an email opened that evening or the next morning; short
 * enough that a forwarded or found email isn't a key for long. After that, the sign-in page as ever.
 */
export const VET_NOW_LINK_S = 24 * 60 * 60;
//# sourceMappingURL=constants.js.map